import { ChainInfo } from '../api/v1/chains'
import { freeze } from '@reduxjs/toolkit'
import { L1ChainId, L2ChainId } from '../types'
import { ChainType } from '../constants/chains'

// This is a static class, so it will be updated globally
// This class is used to get the network information without react hooks
export class NetworkRegistry {
  private static networkList: ChainInfo[] = []

  static update(networks: ChainInfo[]) {
    if (!networks.length) return
    const list = []
    for (const v of networks) {
      list.push(
        freeze({
          ...v,
        }),
      )
    }

    this.networkList = freeze(list)
  }
  static list() {
    return this.networkList
  }
  static byL1(chainId: L1ChainId) {
    return this.networkList.find((v) => v.layerOneChainId === chainId)
  }
  static byL2(chainId: L2ChainId) {
    return this.networkList.find((v) => v.layerTwoChainId === chainId)
  }

  static chainType(chainId: L1ChainId): ChainType | null {
    const network = this.byL1(chainId)
    if (!network) {
      return null
    }
    return network.chainType
  }
}
